<template>
    <MainContent title="Activar Acreditación">
        <template v-slot:header>
            <h3 class="card-title pb-3">Activar Acreditación</h3>
        </template>
        <template v-slot:content>
            <FormAcreditacion v-if="acreditacion" :evento_id="evento_id" :acreditacion="acreditacion" @terminado="editarAcreditacion" :activacion="true"/>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import FormAcreditacion from '@/components/backend/acreditaciones/FormAcreditacion';

    export default {
        props: ['evento_id', 'acreditacion_id'],
        data() {
            return {
                acreditacion: null
            }
        },
        methods: {
            getAcreditacion() {
                this.loading = true;

                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    acreditacion_id: this.acreditacion_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.show'), params).then(res => {
                    this.acreditacion = res.data.data;
                    this.loading = false;
                });
            },
            editarAcreditacion(acreditacionData) {
                this.loading = true;
                this.acreditacion = acreditacionData;
                this.acreditacion.filters = {};
                this.acreditacion.evento_id = this.evento_id;
                this.acreditacion.acreditacion_id = this.acreditacion_id;
                this.acreditacion.estado = 1;

                this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.activar-cancelar'), this.acreditacion).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.go(-1);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => this.loading = false);
            },
        },
        created() {
            this.getAcreditacion();
        },
        components: {
            MainContent, FormAcreditacion
        }
    }
</script>